import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the generateRequestsView.
 * @extends JetView
 */
export default class generateRequestsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with department selection
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for department selection
                    name: 'Department',
                    label: _('Dirigido al Departamento'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: '0', value: _('Tecnología') },
                        { id: '1', value: _('Soporte') },
                        { id: '2', value: _('Financiero') },
                    ],
                    id: 'Departments',
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                },
            ],
        };

        // Center left section with title input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for title
                    name: 'Title',
                    label: _('Título'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Título de la petición'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                },
            ],
        };

        // Center right section with description input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'textarea', // Textarea for description
                    name: 'Description',
                    label: _('Descripción'), // Label for the textarea
                    labelPosition: 'top',
                    placeholder: _('Descripción la petición'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Click event to clear the form
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Generate button
                    value: _('Generar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('registrationRequestsAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-registrationRequestsAdd',
                    click: () => {
                        // Click event to generate request
                        if (this.getRoot().validate()) {
                            // Validate form
                            const request = this.getRoot().getValues(); // Get form values
                            // Set creation date in the request
                            request.CreationDate =
                                webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                ':' +
                                ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                ':' +
                                ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                ' ' +
                                ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                ':' +
                                ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                ':' +
                                ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2);
                            // AJAX request to generate the request
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'requests/generateRequests', // API endpoint
                                    request,
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            // Error handling
                                            webix.message(_('Error! '));
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            // Success handling
                                            var data = JSON.parse(text); // Parse response
                                            webix.message({
                                                text: _('Petición Generada'), // Success message
                                                title: _('¡Exito!'), // Title for the message
                                                type: 'alert-warning',
                                            });
                                            this.app.callEvent('requests:filter', [{}]); // Trigger filter event
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Upper section containing the form fields and buttons
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
                buttons,
            ],
        };

        // Accordion section for grouping the upper section
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Generar Petición'), // Header for the accordion
                            body: {
                                padding: 10,
                                rows: [upper_section], // Body containing the upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form', // Form view
            id: 'formFilter',
            rows: [accordion_section], // Rows containing the accordion section
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Event handler for input changes
                        this.validate(); // Validate the form on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view.
     */
    init() {}
}

// FILE DOCUMENTED
